import { type ApiError } from '@webapp/core/interfaces/api/ApiError'
import {
  type OrderHeaderFieldErrorField,
  type OrderHeaderFieldErrors,
} from '@webapp/modules/purchasing/business-logic/types/OrderHeaderFieldErrors'
import { LegalEntityErrorCodes } from '@webapp/modules/purchasing/business-logic/use-cases/constants/legalEntityErrorCodes'

interface ISentOrderIds {
  secondaryCategoryId: number | undefined
}

const FIELD_ERROR_RULES: {
  apiField: string
  field: OrderHeaderFieldErrorField
  sentIdKey: keyof ISentOrderIds
  codes: ReadonlySet<string>
}[] = [
  {
    apiField: 'department',
    field: 'secondaryCategory',
    sentIdKey: 'secondaryCategoryId',
    codes: new Set([LegalEntityErrorCodes.LEGAL_ENTITY_CHANGE_NOT_ALLOWED]),
  },
]

/**
 * Keeps only the entity errors the edit-details form shows, keyed by form field. `sentIds` are
 * the ids the request carried, so each error stays tied to the value the backend rejected.
 */
export const mapOrderHeaderFieldErrors = (
  errors: ApiError['errors'] | undefined,
  sentIds: ISentOrderIds
): OrderHeaderFieldErrors =>
  FIELD_ERROR_RULES.reduce<OrderHeaderFieldErrors>(
    (result, { apiField, field, sentIdKey, codes }) => {
      const error = errors?.[apiField]
      if (error && codes.has(error.code)) {
        result[field] = {
          code: error.code,
          message: error.message,
          rejectedId: sentIds[sentIdKey] ?? null,
        }
      }
      return result
    },
    {}
  )
